// @generated by protoc-gen-es v1.10.0
// @generated from file common/v1/common.proto (package common.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum common.v1.Technique
 */
export const Technique = /*@__PURE__*/ proto3.makeEnum(
  "common.v1.Technique",
  [
    {no: 0, name: "TECHNIQUE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TECHNIQUE_REWORK", localName: "REWORK"},
    {no: 2, name: "TECHNIQUE_STITCH", localName: "STITCH"},
    {no: 3, name: "TECHNIQUE_PATCHWORK", localName: "PATCHWORK"},
    {no: 4, name: "TECHNIQUE_EMBELLISH", localName: "EMBELLISH"},
    {no: 5, name: "TECHNIQUE_DISTRESS", localName: "DISTRESS"},
    {no: 6, name: "TECHNIQUE_WEAVE_OR_KNOT", localName: "WEAVE_OR_KNOT"},
    {no: 7, name: "TECHNIQUE_PAINT", localName: "PAINT"},
    {no: 8, name: "TECHNIQUE_PRINT", localName: "PRINT"},
    {no: 9, name: "TECHNIQUE_DYE", localName: "DYE"},
  ],
);

/**
 * @generated from enum common.v1.SubTechnique
 */
export const SubTechnique = /*@__PURE__*/ proto3.makeEnum(
  "common.v1.SubTechnique",
  [
    {no: 0, name: "SUB_TECHNIQUE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SUB_TECHNIQUE_DECONSTRUCTION", localName: "DECONSTRUCTION"},
    {no: 2, name: "SUB_TECHNIQUE_RECONSTRUCTION", localName: "RECONSTRUCTION"},
    {no: 3, name: "SUB_TECHNIQUE_REPURPOSE", localName: "REPURPOSE"},
    {no: 4, name: "SUB_TECHNIQUE_EMBROIDERY", localName: "EMBROIDERY"},
    {no: 5, name: "SUB_TECHNIQUE_SHASHIKO", localName: "SHASHIKO"},
    {no: 6, name: "SUB_TECHNIQUE_BORO", localName: "BORO"},
    {no: 7, name: "SUB_TECHNIQUE_PIECEING", localName: "PIECEING"},
    {no: 8, name: "SUB_TECHNIQUE_QUILT", localName: "QUILT"},
    {no: 9, name: "SUB_TECHNIQUE_APPLIQUE", localName: "APPLIQUE"},
    {no: 10, name: "SUB_TECHNIQUE_BEADS", localName: "BEADS"},
    {no: 11, name: "SUB_TECHNIQUE_PATCHES", localName: "PATCHES"},
    {no: 12, name: "SUB_TECHNIQUE_SEQUINS", localName: "SEQUINS"},
    {no: 13, name: "SUB_TECHNIQUE_JEWELS", localName: "JEWELS"},
    {no: 14, name: "SUB_TECHNIQUE_TRIM", localName: "TRIM"},
    {no: 15, name: "SUB_TECHNIQUE_CUTTING", localName: "CUTTING"},
    {no: 16, name: "SUB_TECHNIQUE_FRAYING", localName: "FRAYING"},
    {no: 17, name: "SUB_TECHNIQUE_SANDING", localName: "SANDING"},
    {no: 18, name: "SUB_TECHNIQUE_WIRE_BRUSH", localName: "WIRE_BRUSH"},
    {no: 19, name: "SUB_TECHNIQUE_CROCHET", localName: "CROCHET"},
    {no: 20, name: "SUB_TECHNIQUE_KNIT", localName: "KNIT"},
    {no: 21, name: "SUB_TECHNIQUE_MACRAME", localName: "MACRAME"},
    {no: 22, name: "SUB_TECHNIQUE_BRUSH", localName: "BRUSH"},
    {no: 23, name: "SUB_TECHNIQUE_PENS", localName: "PENS"},
    {no: 24, name: "SUB_TECHNIQUE_SPONGE", localName: "SPONGE"},
    {no: 25, name: "SUB_TECHNIQUE_SPLATTER", localName: "SPLATTER"},
    {no: 26, name: "SUB_TECHNIQUE_AIR_BRUSH", localName: "AIR_BRUSH"},
    {no: 27, name: "SUB_TECHNIQUE_SILK_SCREEN", localName: "SILK_SCREEN"},
    {no: 28, name: "SUB_TECHNIQUE_TRANSFER", localName: "TRANSFER"},
    {no: 29, name: "SUB_TECHNIQUE_BLOCK_PRINT", localName: "BLOCK_PRINT"},
    {no: 30, name: "SUB_TECHNIQUE_TIE_DYE", localName: "TIE_DYE"},
    {no: 31, name: "SUB_TECHNIQUE_BLEACH", localName: "BLEACH"},
    {no: 32, name: "SUB_TECHNIQUE_SHIBORI", localName: "SHIBORI"},
    {no: 33, name: "SUB_TECHNIQUE_BATIK", localName: "BATIK"},
    {no: 34, name: "SUB_TECHNIQUE_CYANOTYPE", localName: "CYANOTYPE"},
  ],
);

